var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_3618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.71254C0 8.35586 0.148171 8.01521 0.409091 7.77201L8.58163 0.154764C8.82238 -0.0515881 9.17762 -0.0515878 9.41837 0.154764L17.5909 7.77201C17.8519 8.01521 18 8.35586 18 8.71254V16.0714C18 17.1365 17.1365 18 16.0714 18H1.92857C0.863451 18 0 17.1365 0 16.0714V8.71254Z",
    fill: "#13100F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14C6 12.8954 6.89543 12 8 12H10C11.1046 12 12 12.8954 12 14V18H6V14Z",
    fill: "#F9DF35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_3618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeActive);
export default __webpack_public_path__ + "static/media/icon_home_active.48d51dbd18fbb06f058171583104db1f.svg";
export { ForwardRef as ReactComponent };